module.exports = __webpack_public_path__ + "static/media/order_blue.65938c5e.svg";